export default __webpack_public_path__ + "static/media/ill-leave-holidays.1058da4c.svg";